// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1XpN_","title":"Header_title__5osUd","left":"Header_left__UAY8B","clinicName":"Header_clinicName__31igT"};